import { type Balance } from '../types/userType';

const balanceItems: Array<keyof Balance> = [
  'cash',
  'point',
  'tgem',
  'dice',
  'usdt',
  'str',
];

export { balanceItems };
